import _extends from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["type", "realtor", "className", "listing"];
var __jsx = React.createElement;
import classNames from 'classnames';
import { DixuCol, DixuRow } from "../DixuGrid/DixuGrid";
import DixuImage from "../DixuImage/DixuImage";
import DixuLink from "../DixuLink/DixuLink";
import DixuText from "../DixuText/DixuText";
import { useTranslation } from "../../i18n";
import React from 'react';
import { getImageUrl } from "../../utils/DixuListingUtils";
import { ContactInfoSource } from "../../utils/DixuConstants";
const DixuRealtorInfo = _ref => {
  let {
      type,
      realtor,
      className,
      listing
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const classes = classNames('dixu-realtor-info', className);
  const {
    t
  } = useTranslation(['listing']);
  const {
    avatar: realtorAvatar,
    name,
    jobTitle,
    companyLogo,
    email: realtorEmail,
    tel: realtorTel,
    companyName,
    companyEmail,
    companyTel
  } = realtor || {};
  const useOfficeDetails = listing.contactInfoSource === ContactInfoSource.OFFICE;
  const email = useOfficeDetails ? companyEmail : realtorEmail;
  const tel = useOfficeDetails ? companyTel : realtorTel;
  const sellerDetails = useOfficeDetails ? companyName : [name, jobTitle].filter(Boolean).join(', ');
  const avatar = useOfficeDetails ? companyLogo : realtorAvatar;
  const title = (() => {
    if (type === 'basic') {
      return name;
    }
    return t('listing:ListingSoldBy', {
      sellerDetails
    });
  })();
  const avatarSize = (() => {
    if (type === 'basic') {
      return 48;
    }
    return 80;
  })();

  // Company logo is shown in avatar if uses office details
  const showCompanyLogo = !useOfficeDetails && companyLogo;
  return /*#__PURE__*/React.createElement("div", _extends({
    className: classes
  }, rest), /*#__PURE__*/React.createElement(DixuRow, {
    justify: "center",
    gutter: [12, 16]
  }, avatar && /*#__PURE__*/React.createElement(DixuCol, null, /*#__PURE__*/React.createElement(DixuImage, {
    src: getImageUrl(avatar),
    type: "circle",
    width: avatarSize
  })), /*#__PURE__*/React.createElement(DixuCol, {
    flex: "1 1 0"
  }, /*#__PURE__*/React.createElement(DixuRow, {
    gutter: [0, 4]
  }, /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuRow, null, /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuText, {
    font: "3",
    color: "2-8",
    weight: "bold",
    wrap: true
  }, title)), tel && /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuLink, {
    href: `tel:${tel}`,
    font: "2",
    color: "2-8",
    decoration: "underline",
    wrap: true
  }, tel)), email && /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuLink, {
    href: `mailto:${email}`,
    font: "2",
    color: "2-8",
    decoration: "underline",
    wrap: true
  }, email)))), showCompanyLogo && /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuRow, null, /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuImage, {
    src: getImageUrl(companyLogo),
    width: "128",
    height: "42",
    aspectRatio: false,
    position: "left",
    fit: "contain"
  }))))))));
};
DixuRealtorInfo.defaultProps = {
  type: undefined
};
export default DixuRealtorInfo;